define([
    "dojo/_base/declare",
    "csi/locale",
    "csi/xml"
], function(declare,locale,xml) {

    return declare(null, {
        
        m_operation: "",
        
        hasToConfirmAction: function() {
            return true;
        },

        confirmAction: function(/*Object*/params) {
            // summary: prompt: “Unfreeze all Prices?” buttons “Unfreeze all prices” and “Leave prices frozen”.
            params = params || {};
            params.title = this.m_action.m_name;
            params.message = locale.typeAction("PriceList", "UnfreezeAllPrices_Confirm");
            params.buttons = ["UNFREEZE_PRICES", "KEEP_PRICES_FROZEN"];
            this.inherited(arguments);
        },

        onConfirm: function(/*String*/key) {
            // summary: set KeepBaseline to true if confirmed
            this._bUnfreezePrices = (key == "UNFREEZE_PRICES");
            this.preProcess();
        },

        toWriterRequest: function() {
            // summary: add UnfreezePrices boolean parameter to request
            this.m_action.m_request.m_module = "Apparel";
            this.m_action.m_request.m_operation = this.m_operation;
            return this.inherited(arguments).addParameter("UnfreezePrices", xml.ATTR_BOOLEAN, this._bUnfreezePrices);
        }
        
    });
});